module.exports = __webpack_public_path__ + "static/aidr-0e9b6f49f3476a134fcc79c8d29a4804.jpeg";